(() => {
  if (window.kvsB2BInquiryInitialized) return;
  window.kvsB2BInquiryInitialized = true;

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const trigger = event.target.closest?.('a[data-b2b-inquiry-topic]');
    const anchor = trigger?.getAttribute('href');
    if (!trigger || !anchor?.startsWith('#')) return;
    const inquiry = document.getElementById(anchor.slice(1));
    if (!inquiry) return;
    // Uvnitř jedné sekce .kvs-b2b platí jen její formulář; odkaz z jiné sekce B2B stránky
    // (karty cílových skupin, minerály, sortiment) míří na samostatnou sekci s formulářem.
    const section = trigger.closest('.kvs-b2b');
    if (section ? !section.contains(inquiry) : !inquiry.closest('.kvs-b2b')) return;
    const subject = inquiry.querySelector('select[data-b2b-inquiry-subject]');
    const option = subject && Array.from(subject.options).find((item) => item.dataset.b2bInquiryTopic === trigger.dataset.b2bInquiryTopic);
    if (option && subject.value !== option.value) {
      subject.value = option.value;
      subject.dispatchEvent(new Event('change', { bubbles: true }));
    }
    const interest = inquiry.querySelector('select[data-b2b-interest-select]');
    const interestOption = interest && Array.from(interest.options).find((item) => item.dataset.b2bInterest === trigger.dataset.b2bInterest && trigger.dataset.b2bInterest);
    if (interestOption && interest.value !== interestOption.value) {
      interest.value = interestOption.value;
      interest.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
})();
